import { useState } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CloseIcon from '@mui/icons-material/Close';
import theme from 'theme';

// Release notes / changelog URL — swap for the final link.
const WHATS_NEW_URL = 'https://adaptive-drive-733.notion.site/WinFi-Wiki-380b3664336e80f1b25de04b0d227b41';

const DISMISS_KEY = 'whatsNewDismissed';

const WhatsNewButton = () => {
  const [visible, setVisible] = useState(
    () => sessionStorage.getItem(DISMISS_KEY) !== 'true',
  );

  if (!visible) return null;

  const handleOpen = () => {
    window.open(WHATS_NEW_URL, '_blank', 'noopener,noreferrer');
  };

  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation();
    sessionStorage.setItem(DISMISS_KEY, 'true');
    setVisible(false);
  };

  return (
    <Box
      onClick={handleOpen}
      role='button'
      aria-label="What's New"
      sx={{
        position: 'fixed',
        bottom: { xs: 16, sm: 24 },
        left: { xs: 16, sm: 24 },
        zIndex: theme.zIndex.modal,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        pl: 2,
        pr: 1,
        py: 1,
        borderRadius: '999px',
        cursor: 'pointer',
        color: '#fff',
        backgroundColor: 'primary.main',
        boxShadow: '0 4px 14px rgba(0, 0, 0, 0.25)',
        transition: 'background-color 0.2s ease, transform 0.2s ease',
        ':hover': {
          backgroundColor: 'primary.dark',
          transform: 'translateY(-2px)',
        },
      }}
    >
      <AutoAwesomeIcon sx={{ fontSize: 20 }} />
      <Typography sx={{ color: '#fff', fontWeight: 600, fontSize: '14px' }}>
        What's New
      </Typography>
      <IconButton
        size='small'
        onClick={handleClose}
        aria-label="Dismiss What's New"
        sx={{
          color: '#fff',
          p: '2px',
          ':hover': { backgroundColor: 'rgba(255, 255, 255, 0.15)' },
        }}
      >
        <CloseIcon sx={{ fontSize: 16 }} />
      </IconButton>
    </Box>
  );
};

export default WhatsNewButton;
